import type { CountryCode } from 'libphonenumber-js';

export const WEBSOCKET_HEARTBEAT_INTERVAL_DEFAULT = 15 * 1000;
export const WEBSOCKET_RECONNECT_TIMEOUT_DEFAULT = 60 * 1000;

export const MAX_FIND_PROVIDER_ATTEMPTS = 3;
export const MAX_EXCEPTION_RESOLVE_ATTEMPTS = 2;

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 40, 50, 100];

export const NOTE_INPUT_DEFAULT_CHARACTER_LIMIT = 100;

export const NON_MEMBER_PORTAL_NAMES = ['reservations', 'f1'];
export const MEMBER_PORTAL_NAMES = [
  'mvp',
  'dentaquest',
  'ahc',
  'ahcadmin',
  'transport',
];

export const EDIT_MEMBER_PROFILE_NOT_ALLOWED_PORTAL_NAMES = ['ahcadmin'];
export const STANDING_ORDER_NOT_ALLOWED_PORTAL_NAMES = ['ahcadmin', 'ahc'];
export const MEMBER_PORTAL_NO_BENEFIT_PLAN_NAMES = [
  'No Transportation Benefits',
  'No Transportation Benefit',
];
export const NEXT_TWO_DAYS_APPOINTMENT_NOT_ALLOWED_PORTAL_NAMES = [
  'ahc',
  'transport',
  'mvp',
  'dentaquest',
];

export const PHONE_VALIDATION_COUNTRIES: CountryCode[] = ['US'];

/**
 * Portal specific configuration settings
 */
export const MEMBER_PORTAL_EXCLUDED_PURPOSE_NAMES = [
  'dialysis',
  'chemotherapy',
];

/** Wait after form values change before calling the reservation `/validate` API (via `FIELD_EDITED`). */
export const RESERVATION_VALIDATE_DEBOUNCE_MS = 200;

/** Debounces the Reservation Form footer buttons so they don't flicker while state is updating */
export const RESERVATION_ACTION_BUTTON_DEBOUNCE_MS = 200;

/**
 * Debounces refetches triggered by websocket events (e.g. a full standing-order
 * cancel emits a long cascade of reservation/trip-leg events). Settle this long
 * after events stop before refetching; `MAX_WAIT` guarantees a refresh at least
 * this often during a sustained cascade so the UI never looks frozen.
 */
export const RESERVATION_REFETCH_DEBOUNCE_MS = 1000;
export const RESERVATION_REFETCH_MAX_WAIT_MS = 5000;

// Midnight cutoff hours for pickup date auto-defaulting (0-23)
// Appointments between 12:00 AM and this hour default pickup to previous day
export const MIDNIGHT_CUTOFF_HOURS = 3;

// Attribute Hardcoded limits
export const MAX_HEIGHT = 74;
export const MAX_WEIGHT = 250;

export const STAIRS_COUNT_BC = 'STAIRS_COUNT';
export const OXYGEN_LITERS_BC = 'OXYGEN_LITERS';
export const GURNEY_BC = 'GURNEY';
export const BARIATRIC_GURNEY_BC = 'BARIATRIC_GURNEY';
export const NON_AMBULATORY_BC = 'NONAMBULATORY';
export const AMBULATORY_BC = 'AMBULATORY';
export const WHEELCHAIR_BC = 'WHEELCHAIR';
export const R2R_BC = 'R2R';
export const C2C_BC = 'C2C';
export const D2D_BC = 'D2D';

export const RESERVATION_CONFLICT_MESSAGE_IDS = [
  'RESERVATION_CONFLICT',
  'STO_CONFLICT',
];

export const API_ERROR_MAX_RETRIES = 3;
export const API_ERROR_RETRY_BASE_DELAY_MS = 200;
export const API_ERROR_DEFAULT_RATE_LIMIT_DELAY_MS = 1000;
